<template>
  <b-row class="flex-fill" no-gutters>
    <b-col cols="7" style="background-color: lightgrey">
      ToDo: place map here
    </b-col>
    <b-col class="pr-1 pb-1 pl-1" id="contentRight">
      <div class="sticky-top border pr-1 pb-1 pl-1" style="background-color: white;">
        <div style="height: 4px"></div>
        <b-alert v-for="(error, index) in errors" variant="danger" :key="'error_' + index" class="mb-1" show>
          {{ error }}
        </b-alert>
        <b-alert v-if="!user.loggedIn" variant="info" class="mb-0 p-2" show>
          <small>
            <b>Info:</b> The 10 most recent added POIs are displayed.
            <i><b-link :to="{ name: 'login' }">Login</b-link></i> to browse all POIs.
          </small>
        </b-alert>
        <div v-if="user.loggedIn" class="d-flex">
          <b-button
            v-if="user.data.profile.roles.includes('contributor')"
            variant="primary"
            :to="{ name: 'poi-add' }"
            size="sm"
          >
            Add POI
          </b-button>
          <b-form-checkbox
            v-model="mypois"
            class="ml-auto"
            v-b-tooltip.hover
            title="display the POIs you have contributed"
            @change="getPoiRecords"
          >
            my POIs
          </b-form-checkbox>
        </div>
      </div>
      <div v-for="(poi, index) in pois" :key="'poi_' + index">
        <PoiCard :poi="poi" />
      </div>
      <b-alert v-if="!pois.length && !loading" class="mt-1 pt-2 pb-2" show>
        Sorry. No POIs to display.
      </b-alert>
      <SpinnerDiv :display="loading" class="mt-2" />
    </b-col>
  </b-row>
</template>

<script>
import PoiCard from '@/components/PoiCard';
import { mapGetters } from 'vuex';

import SpinnerDiv from '../components/helpers/SpinnerDiv';

export default {
  name: 'PoisView',
  components: { PoiCard, SpinnerDiv },
  computed: {
    ...mapGetters({ pois: 'poi/records', user: 'auth/user' }),
  },
  data() {
    return {
      errors: [],
      loading: false,
      mypois: this.$route.query.mypois === 'true' || this.$route.query.mypois === '1',
    };
  },
  created() {
    if (!this.pois.length) {
      this.getPoiRecords();
    }
  },
  methods: {
    getPoiRecords(evt = false) {
      // calls dispatch to reload poi records (via getter poi/records)
      const payload = {
        uid: this.user.data ? this.user.data.uid : false,
        validated: true,
        order_by: 'geojson.properties.taken_at',
        order_dir: 'desc',
        // ToDo: add pagination -> until then, limit result to 10...
        limit: 10,
      };
      evt ? (payload.mypois = true) : null;

      this.loading = true;
      this.$store.dispatch('poi/bindRecords', payload).finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
#contentRight {
  overflow-y: auto;
  height: calc(100vh - 96px);
}
</style>
